import React, { useEffect } from "react";
import { Button } from "reactstrap";
import { useForm } from "react-hook-form";
import { useState } from "react";
import ControlledInput from "../../Forms/Controller/ControlledInput";
import { useRole } from "../../../../redux/slices/authSlice";
import ControlledDropDown from "../../Forms/Controller/ControlledDropDown";
import { MdDelete } from "react-icons/md";
import InputField from "../../Forms/InputField/InputField";
import { PaymentMetaLabelListGet } from "../../../../redux/slices/transactionSlice";
import { useDispatch, useSelector } from "react-redux";
import { showToaster } from "../../../../constant";
import CustomeButton from "../../Forms/CustomeButton/CustomeButton";

const Percentage = (props) => {
  const {
    onCloseChangeBankModal,
    changeBankModal,
    merchants,
    bankId,
    bankOptions,
    paymentMetaLabelListGetData,
    preparepgDataOptions,
    showTableData,
    percentageList,
    setPercentageList,
    handleSubmit,
    submitLoader,
  } = props;
  const [merchantList, setMerchantList] = useState([]);
  const [paymentMetaLabelListGetData1, setPaymentMetaLabelListGetData1] =
    useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState({
    pgLoading: false,
    pgAccLoading: false,
  });
  const { transactionFilterState } = useSelector((state) => state.transaction);
  const role = useRole("Static Pg Meta");
  const dispatch = useDispatch();

  const bankName = paymentMetaLabelListGetData?.data?.find((data) => {
    return data?.acId == bankId;
  })?.note;

  const initialValues = {
    merchantEmail: "",
    merchantName: "",
    Mode: "merchant",
    BankSelect: "",
    BankPercentage: "",
    MerchantSelect: "",
    BankForMerchant: "",
    pgName: "",
  };

  const {
    control,
    getValues,
    setValue,
    setError,
    watch,
    clearErrors,
    resetField,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues,
  });

  const PaymentMetaLabelList = async () => {
    try {
      const pgName = transactionFilterState?.pg_data?.find((data) => {
        return data?.pg_id == watch("pgName");
      });
      let payload = {
        pgType: "payin",
        pgName: pgName?.pg_name ? [pgName?.pg_name] : "All",
        pg_id: watch("pgName") || "all",
        notSetState: true,
      };
      setLoading({ ...loading, pgAccLoading: true });
      const res = await dispatch(PaymentMetaLabelListGet(payload)).unwrap();
      if (res?.status) {
        setPaymentMetaLabelListGetData1(res);
      }
      setLoading({ ...loading, pgAccLoading: false });
    } catch (e) {
      setLoading({ ...loading, pgAccLoading: false });
    }
  };

  const pgName = watch("pgName");

  useEffect(() => {
    if (pgName && changeBankModal) {
      PaymentMetaLabelList(); // make sure this doesn’t itself set pgName
    }
  }, [pgName, changeBankModal]);

  const extractValue = (field) => {
    if (field == null) return "";
    if (typeof field === "object" && "value" in field) return field.value;
    return field;
  };

  const findLabel = (options, val) => {
    const found = options?.find?.((o) => o.value === val || o.label === val);
    return found ? found.label : val;
  };

  const handleAddPercentage = async (
    bank,
    value,
    fromBank = "",
    toBank = "",
    pgNameVal = ""
  ) => {
    if (!showTableData && !changeBankModal?.pg_id) {
      const total = [
        ...percentageList,
        { bank, value, fromBank, toBank, pgNameVal },
      ]?.reduce?.((sum, item) => sum + (item?.value || 0), 0);

      const isHundred = total === 100;

      if (!isHundred) {
        showToaster(`Percentage total must be 100%, got ${total}%`, "Warning");
        return;
      }
    }
    const total = percentageList.reduce(
      (acc, cur) => acc + Number(cur.value || 0),
      0
    );
    if (isNaN(value) || value <= 0) {
      alert("Please enter a valid percentage > 0");
      return;
    }
    if (total + value > 100) {
      setFormErrors({ exceed: "Total percentage cannot exceed 100%" });
      return;
    } else {
      setFormErrors({ exceed: "" });
    }

    const exists = percentageList?.some?.(
      (item) => item?.bank === bank && item?.fromBank === fromBank
    );

    if (exists) {
      showToaster(
        "A record with the same bank and fromBank already exists!",
        "Warning"
      );
      return;
    }
    setPercentageList([
      ...percentageList,
      { bank, value, fromBank, toBank, pgNameVal },
    ]);

    if (!showTableData && !changeBankModal?.pg_id) {
      await handleSubmit?.([
        ...percentageList,
        { bank, value, fromBank, toBank, pgNameVal },
      ]);
    }
    setValue("fromBank", "");
    setValue("BankSelect", "");
    setValue("BankPercentage", "");
    setValue("pgName", "");
  };

  const handleDeletePercentage = (index) => {
    const newList = [...percentageList];
    newList.splice(index, 1);
    setPercentageList(newList);
  };

  const onClickAddPercentage = () => {
    const bankPerField = getValues("fromBank");
    const pgName = getValues("pgName");
    const bankField = getValues("BankSelect");
    const percentField = getValues("BankPercentage");
    const pgNameVal = extractValue(pgName);
    const bankPerVal = extractValue(bankPerField);
    const bankVal = extractValue(bankField);
    const percent = Number(percentField);

    if (!bankPerVal && !showTableData && !changeBankModal?.pg_id) {
      setError("fromBank", {
        type: "manual",
        message: "Please select from bank.",
      });
      return;
    } else {
      clearErrors("fromBank");
    }

    if (!pgNameVal) {
      setError("pgName", {
        type: "manual",
        message: "PG Name Is Required",
      });
      return;
    } else {
      clearErrors("pgName");
    }

    if (!bankVal) {
      setError("BankSelect", {
        type: "manual",
        message: "Please select bank.",
      });
      return;
    } else {
      clearErrors("BankSelect");
    }

    if (isNaN(percent) || percent <= 0) {
      setError("BankPercentage", {
        type: "manual",
        message: "Please enter a valid percentage.",
      });
      return;
    } else {
      clearErrors("BankPercentage");
    }
    const toBankName = paymentMetaLabelListGetData1?.data?.find((data) => {
      return data?.acId == bankField;
    })?.note;
    handleAddPercentage(bankVal, percent, bankPerField, toBankName, pgNameVal);
  };

  const getpgAccDataOptions = () => {
    const options = paymentMetaLabelListGetData1?.data
      ?.slice()
      ?.sort((a, b) => a?.note?.localeCompare(b?.note))
      ?.map((val) => {
        const pgAccDataOption = { value: val?.acId, label: val?.note };
        return pgAccDataOption;
      });
    return options;
  };

  const allMerchantOptions = React.useMemo(() => {
    return (
      merchants?.slice()?.map?.((val) => ({
        value: val?.merchant_details?.merchant_id,
        label: val?.merchant_details?.admin_merchant_name,
      })) || []
    );
  }, [merchants]);

  const allBankOptions = React.useMemo(() => {
    return (
      bankOptions?.filter?.((options) => {
        return options?.value !== bankName;
      }) || []
    );
  }, [bankOptions]);

  const prepareBankOptions = React.useMemo(() => {
    const addedIds = percentageList?.map?.((m) => m?.bank);
    return allBankOptions?.filter?.((opt) => !addedIds?.includes?.(opt?.value));
  }, [allBankOptions, percentageList]);

  const usedMerchantPerBanks = React.useMemo(() => {
    return percentageList?.map?.((m) => m?.bank) || [];
  }, [percentageList]);

  const filteredToBanksForAll = React.useMemo(() => {
    return getpgAccDataOptions()?.filter?.(
      (opt) => opt.value !== watch("fromBank")
    );
  }, [getpgAccDataOptions, watch("fromBank"), watch("pgName")]);

  const usedMerchantBanks = React.useMemo(() => {
    return merchantList?.map?.((m) => m?.fromBank) || [];
  }, [merchantList]);

  const filteredToBanks = React.useMemo(() => {
    return getpgAccDataOptions()?.filter?.(
      (opt) => opt.value !== changeBankModal?.pg_id
    );
  }, [getpgAccDataOptions, changeBankModal?.pg_id, watch("pgName")]);

  const fromBankPerOptions = React.useMemo(() => {
    return getpgAccDataOptions()?.filter?.(
      (opt) => !usedMerchantPerBanks?.includes?.(opt.value)
    );
  }, [getpgAccDataOptions, usedMerchantPerBanks]);

  const bankPerForMerchantOptions = React.useMemo(() => {
    return fromBankPerOptions?.filter?.((opt) => opt.value !== bankId);
  }, [fromBankPerOptions, bankId, watch("pgName")]);

  if (!role.includes("static-pg-meta-list") || !changeBankModal) {
    return;
  }

  return (
    <>
      {formErrors?.exceed ? (
        <span style={{ color: "red", fontSize: 12 }}>{formErrors?.exceed}</span>
      ) : null}
      <div className="change_grid mb-1">
        {!showTableData && !changeBankModal?.pg_id ? (
          <ControlledDropDown
            name="fromBank"
            label="From Bank"
            options={allBankOptions}
            onChange={(e) => {
              setValue("fromBank", e?.value);
              resetField("BankSelect");
              resetField("pgName");
              setPaymentMetaLabelListGetData1([]);
              if (e?.value) {
                clearErrors("fromBank");
              }
            }}
            isDisabled={!allBankOptions?.length}
            control={control}
            errors={errors}
          />
        ) : (
          <InputField
            name="fromBank"
            readOnly
            value={
              showTableData && !changeBankModal?.pg_id
                ? bankName
                : changeBankModal?.bank_details?.label
            }
            label="From Bank"
          />
        )}
        <ControlledDropDown
          label="PG"
          name="pgName"
          isDefaultOption={false}
          isDisabled={!prepareBankOptions?.length}
          options={preparepgDataOptions}
          onChange={(e) => {
            setValue("pgName", e?.value);
            resetField("BankSelect");
            if (e?.value) {
              clearErrors("pgName");
            }
          }}
          control={control}
          errors={errors}
        />
        <ControlledDropDown
          label="PG Account"
          name="BankSelect"
          isDisabled={!prepareBankOptions?.length || loading?.pgAccLoading}
          isDefaultOption={false}
          isLoading={loading?.pgAccLoading}
          options={
            !showTableData && !changeBankModal?.pg_id
              ? filteredToBanksForAll
              : !showTableData && !!changeBankModal?.pg_id
                ? filteredToBanks
                : bankPerForMerchantOptions
          }
          control={control}
          errors={errors}
        />
        <ControlledInput
          name="BankPercentage"
          type="number"
          label="Enter %"
          isDisabled={!prepareBankOptions?.length}
          placeholder="Enter percentage"
          control={control}
          errors={errors}
        />
        <div style={{ marginTop: "28px" }}>
          <CustomeButton
            type="button"
            className="btn btn-primary"
            onClick={onClickAddPercentage}
            isButtonLoading={
              submitLoader && !showTableData && !changeBankModal?.pg_id
            }
          >
            {!showTableData && !changeBankModal?.pg_id ? "Submit" : "Add"}
          </CustomeButton>
        </div>
      </div>

      {percentageList?.length &&
        !(!showTableData && !changeBankModal?.pg_id) ? (
        <div>
          <div
            className={`${!showTableData && !changeBankModal?.pg_id
                ? "change_bank_grid"
                : "change_bank_grid_1"
              } change_bank_header`}
          >
            {!showTableData && !changeBankModal?.pg_id ? (
              <span>From Bank</span>
            ) : null}
            <span>To Bank</span>
            <span>Bank</span>
            <span>Action</span>
          </div>
          {percentageList?.map?.((item, idx) => (
            <div
              key={idx}
              className={`${!showTableData && !changeBankModal?.pg_id
                  ? "change_bank_grid"
                  : "change_bank_grid_1"
                }`}
            >
              {!showTableData && !changeBankModal?.pg_id ? (
                <span>{findLabel(bankOptions, item.fromBank)}</span>
              ) : null}
              <span>{item?.toBank}</span>
              <span>{item.value}%</span>
              <Button
                type="button"
                color="danger"
                onClick={() => handleDeletePercentage(idx)}
              >
                <MdDelete />
              </Button>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default Percentage;
